import { render } from "./FeedbackPin.vue?vue&type=template&id=0a7c3878&scoped=true&ts=true"
import script from "./FeedbackPin.vue?vue&type=script&lang=ts"
export * from "./FeedbackPin.vue?vue&type=script&lang=ts"

import "./FeedbackPin.vue?vue&type=style&index=0&id=0a7c3878&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7c3878"]])

export default __exports__